import React, { useEffect, useState } from "react";
import { collection, getDocs, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";
import InvoiceLineEditor from "../components/InvoiceLineEditor";


const InvoiceBuilderPPD = ({ job }) => {
  const [serviceLines, setServiceLines] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [presets, setPresets] = useState({
    descriptions: [],
    materials: []
  });

  useEffect(() => {
    const fetchPresets = async () => {
      const descSnap = await getDocs(collection(db, "invoicePresets/descriptions/items"));
      const matSnap = await getDocs(collection(db, "invoicePresets/materials/items"));

      setPresets({
        descriptions: descSnap.docs.map(d => ({ id: d.id, ...d.data() })),
        materials: matSnap.docs.map(d => ({ id: d.id, ...d.data() }))
      });
    };

    fetchPresets();
  }, []);

  const saveInvoice = async () => {
    await addDoc(collection(db, "invoices"), {
      jobId: job.id,
      siteName: job.siteName,
      companyName: job.companyName,
      serviceLines,
      materials,
      submittedBy: job.assignedTech || "",
      createdAt: serverTimestamp()
    });

    alert("Invoice saved");
  };

  return (
    <div>
      <h2>Invoice – {job.siteName}</h2>

      <InvoiceLineEditor
        label="Services Performed"
        lines={serviceLines}
        setLines={setServiceLines}
        presets={presets.descriptions}
      />

      <InvoiceLineEditor
        label="Materials Used"
        lines={materials}
        setLines={setMaterials}
        presets={presets.materials}
      />

      <button onClick={saveInvoice} className="blue-button">
        Save Invoice
      </button>
    </div>
  );
};

export default InvoiceBuilderPPD;
